export default __webpack_public_path__ + "static/media/Rectangle 503.7b87b6d2.png";